module.exports = {
  title: 'iOS 26 Home',
  author: 'Enzo Manuel Mangano',
  date: '2025-07-01',
  slug: 'ios-home-bouncy',
  tags: ['reanimated', 'gesture-handler', 'expo-blur'],
};
